import { StrictMode, createRoot } from "@wordpress/element";
import SliderComerciosGrid from "./SliderComerciosGrid";

// Mount the component to the 'root' div
const root = document.getElementById('slider-comercios-grid-swiper');
if (root) {
  const perSlide = root.getAttribute('data-per-slide') ?? 5;
  createRoot(root).render(
    <StrictMode>
      <SliderComerciosGrid perSlide={perSlide} />
    </StrictMode>
  );
}
